import { MediaItem } from '../store/Entities/Media/media.reducer';
import { CallApiOptions } from './api';
import { AppConfig } from '../store/Entities/Stories/stories.reducer';
import { S3Video } from '../modules/StoryEdit/components/Stream/Editors/TileEditor';
import { InitialStory } from '../modules/StoryCreate/index';
import { Layout } from '../modules/StoryEdit/components/Stream/Editors/LayoutEditor';

export const storyCreateCallOptions = (
  initialStory: InitialStory
): CallApiOptions => {
  const {
    appConfigId,
    gender,
    ageMax,
    ageMin,
    storyName,
    storyColor,
    storyType,
    contentType,
    resourceId,
    resourceType,
    isPrimary,
    isSponsored,
    isBasSponsored,
    isSale,
    isPremium,
    isHidden,
    isProductRowDisabled,
    isSecondhand,
  } = initialStory;

  const postData = {
    name: storyName,
    color: storyColor,
    initial_app_id: appConfigId,
    age_from: ageMin,
    age_to: ageMax,
    gender,
    content_type: contentType,
    type: storyType,
    resource_id: resourceId,
    resource_type: resourceType,
    is_primary: isPrimary,
    is_sponsored: isSponsored,
    is_bas_sponsored: isBasSponsored,
    is_sale: isSale,
    is_premium: isPremium,
    is_hidden: isHidden,
    is_product_row_disabled: isProductRowDisabled,
    is_secondhand: isSecondhand,
  };

  return {
    method: 'POST',
    endpoint: `stories`,
    params: {
      include: 'clusters,appConfigs.sourceCategories,targetCategories,rows',
    },
    body: JSON.stringify(postData),
  };
};
const includeparams = [
  'clusters',
  'appConfigs.sourceCategories',
  'targetCategories',
  'rows',
  'appConfigs.errors',
];
export const getStoryCallOptions = (storyId: Number): CallApiOptions => ({
  method: 'GET',
  endpoint: `stories/${storyId}`,
  params: {
    include: includeparams.join(','),
  },
});

export function mapAppConfig(appConfig: AppConfig, outfitIds?: number[]): ApiAppConfig {
  return {
    id: appConfig.id ? appConfig.id : void 0,
    app_id: appConfig.app_id,
    active_from: appConfig.active_from || null,
    active_to: appConfig.active_to || null,
    boost_from: appConfig.boost_from || null,
    boost_to: appConfig.boost_to || null,
    rebrushed_at: appConfig.rebrushed_at || null,
    is_valid: appConfig.is_valid || false,
    is_active: appConfig.is_active || false,
    stream_category_id: appConfig.stream_category_id,
    stream_product_ids: appConfig.stream_product_ids,
    brand_ids: appConfig.brand_ids,
    idol_ids: appConfig.idol_ids,
    product_ids: appConfig.product_ids,
    outfit_ids: outfitIds || [],
  };
}

export interface ApiStory {
  id: number;
  name: string;
  color: string;
  type: string;
  initial_app_id: number;
  resource_id: number | null;
  resource_type: string | null;
  content_type: string | null;
  headline: object | null;
  subline: object | null;
  headline_long?: object | null;
  subline_long?: object | null;
  gender: string | null;
  age_from: number | null;
  age_to: number | null;
  appConfigs: {
    data: ApiAppConfig[];
  };
  is_primary?: boolean;
  is_sponsored?: boolean;
  is_bas_sponsored?: boolean;
  is_sale?: boolean;
  is_premium?: boolean;
  is_hidden?: boolean;
  is_product_row_disabled?: boolean;
  is_secondhand?: boolean;
  header_image_brand_id?: number | null;
  larger_desktop_teaser?: boolean;
  appImage?: MediaItem;
  mobileImage?: MediaItem;
  desktopImage?: MediaItem;
  ownerImage?: MediaItem;
  rows: object;
  clusters: {
    data: ApiCluster[];
  };
}

export interface ApiCluster {
  id?: number;
  name: string;
  headline?: object;
  subline?: object;
  text?: object;
  slug?: string;
  mobile_image_id?: number;
  desktop_image_id?: number;
}

export interface ApiRow {
  id?: number;
  position: number;
  type: string;
  elements: {
    data: ApiElement[];
  };
  mobile_tile_ratio?: number;
  desktop_tile_ratio?: number;
  double_tile_shifted?: 1 | 0;
  row_count?: number;
  layout_order?: Layout;
}

export interface ApiElement {
  id?: number;
  type: string;
  text?: { [key: string]: string };
  resource_type?: string | null;
  resource_id?: number | null;
  url?: string | null;
  additional_resource_data?: {
    brand_id: number;
  };
  position: number;
  header_image_brand_id?: number | null;
  larger_desktop_teaser?: boolean;
  appImage?: MediaItem;
  mobileImage?: MediaItem;
  desktopImage?: MediaItem;
  mobileVideo?: S3Video;
  desktopVideo?: S3Video;
  tracking_id?: string;
  product_id?: number;
  outfit_id?: number;
}

export interface ApiAppConfig {
  id?: number;
  app_id: number;
  active_from?: string | null;
  active_to?: string | null;
  boost_from?: string | null;
  boost_to?: string | null;
  rebrushed_at?: string | null;
  is_valid: boolean;
  is_active: boolean;
  stream_category_id?: number;
  stream_product_ids?: number[];
  brand_ids?: number[];
  idol_ids?: number[];
  product_ids?: number[];
  outfit_ids?: number[];
  sourceCategories?: {
    data: ApiSourceCategory[];
  };
  targetCategories?: {
    data: ApiTargetCategory[];
  };
}

export interface ApiSourceCategory {
  id?: number;
  category_id: number;
  price_from?: number;
  price_to?: number;
  attributeFilters?: {
    data: ApiAttributeFilter[];
  };
}

export interface ApiTargetCategory {
  id?: number;
  app_config_id?: number;
  category_id: number;
  is_pinned: boolean;
}

export interface ApiAttributeFilter {
  id?: number;
  source_category_id?: number;
  attribute_group_id: number;
  attribute_ids: number[];
}



// WEBPACK FOOTER //
// ./src/services/story.services.ts